"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const achievementsRouter = {
  path: '/achievements',
  component: _index.default,
  redirect: 'achievements',
  name: 'Achievements',
  meta: {
    title: 'achievements.title',
    icon: 'achievement'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "achievements-list" */'@/views/achievements/list.vue'))),
    name: 'AchievementsList',
    meta: {
      title: 'achievements.title',
      noCache: true,
      icon: 'achievement'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/achievements/manage.vue'))),
    name: 'EditAchievement',
    props: {
      isEdit: true
    },
    meta: {
      title: 'achievements.edit',
      noCache: true,
      activeMenu: '/achievements/list',
      hidden: true
    }
  }, {
    path: 'add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/achievements/manage.vue'))),
    name: 'AddAchievement',
    props: {
      isEdit: false
    },
    meta: {
      title: 'achievements.add',
      noCache: true,
      activeMenu: '/achievements/list',
      hidden: true
    }
  }]
};
var _default = exports.default = achievementsRouter;